import { useCallback } from 'react';
import { useRouter } from 'next/router';

export default () => {
  const router = useRouter();
  const queryParams = router.query;

  const getQuickResponseQueryParams = useCallback(() => {
    return {
      utmContentValue: queryParams.utm_content?.toString() || null,
      predictionValue: queryParams.prediction?.toString() || null,
    };
  }, [queryParams]);

  const removeQuickResponseQueryParams = useCallback(() => {
    delete router.query.utm_content;
    return router.replace({
      pathname: router.pathname,
      query: router.query,
    });
  }, [router.query]);

  return {
    getQuickResponseQueryParams,
    removeQuickResponseQueryParams,
  };
};
